/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useContext } from 'react';
import './main.css';
import UnifiedDisplayLoads from './UnifiedLoad/UnifiedDisplayLoads';
import { StoreContext } from './Store';

const ListUnifiedLoads = () => {
  const [requestFailed, setRequestFailed] = useState(false);
  const store = useContext(StoreContext);

  useEffect(() => {
    async function fetchData() {
      try {
        store.resetNewLoad();
      } catch (err) {
        setRequestFailed(true);
      }
    }
    fetchData();
  }, []);

  if (requestFailed) return <p>Failed!</p>;

  return (
    <div className="main">
      <section>
        <UnifiedDisplayLoads />
      </section>
    </div>
  );
};

export default ListUnifiedLoads;
